export default __webpack_public_path__ + "assets/puertorico-flag.png";